module.exports = __webpack_public_path__ + "fonts/fa-regular-400.f5f2566b.woff2";